/**
 * Remember to add globalMessageAnnouncer div if not added
 * @returns all exposed methods
 */

const accessibility = () => {
  //Remember to translate messages
  const globalAccessibilitySpeakerId = "globalMessageAnnouncer";

  /**
   *
   * @param {*} id usually used const exposed here such as globalAccessibilitySpeakerId
   * @param {*} message string to be announced, needs to be translated!
   * @param {*} callback function to be called after announce
   */
  const announceMessage = (
    id = "globalMessageAnnouncer",
    message,
    callback,
  ) => {
    if (id && message) {
      var liveRegion = document.getElementById(id);

      if (liveRegion) {
        liveRegion.textContent = message;
      }
    }
    if (callback && typeof callback === "function") {
      callback();
    }
  };

  return {
    announceMessage: announceMessage,
    globalAccessibilitySpeakerId: globalAccessibilitySpeakerId,
  };
};

export default accessibility;
